import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=28e9419f&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=ts&"
export * from "./Media.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9419f",
  null
  
)

/* custom blocks */
import block0 from "./Media.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports